var map = {
	"./africa/lobby.vue": [
		"rDNZ",
		4
	],
	"./club-soft/lobby.vue": [
		"KXAL",
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Dil8";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/lobby lazy ^\.\/.*\/lobby\.vue$
// module id = Dil8
// module chunks = 37